<div class="loader-container" role="status">
  <div class="loader">{{ 'spinner.loading' | cxTranslate }}</div>
</div>
